export const SUBSCRIPTION_MODAL_BENEFITS = {
  posts: [
    [
      'Internal/client workflow & collaboration',
      'Organized social media content',
      'Live desktop/mobile post previews',
    ],
    ['Scheduling and auto-publishing', 'Analytics & reporting', ' …and more!'],
  ],
  insights: [
    [
      'In depth page performance',
      'Overview of best performing posts',
      'Competition analysis',
    ],
    ['Customizable reports', 'Data export to PDF and CSV', ' …and more!'],
  ],
};
